import { render, staticRenderFns } from "./FRegionTable.vue?vue&type=template&id=286f223c&scoped=true"
import script from "./FRegionTable.vue?vue&type=script&lang=js"
export * from "./FRegionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f223c",
  null
  
)

export default component.exports